'use client';

import Image from 'next/image';
import { useEffect, useRef, useState } from 'react';
import ImageGallery from 'react-image-gallery';

import { ImageCarouselModal } from '@/components/atomic/nuclei';
import { mediaStoreBaseURL, staticMediaStoreBaseURL } from '@/config/common';
import { getRankedImages, itemImageDefault } from '@/helpers/carousel';
import { useIsMobile } from '@/lib/screenResolution';

const parseProductMedia = (productMediaRaw) => {
  if (productMediaRaw.length === 0) return [itemImageDefault];
  return productMediaRaw.map(({ media: { id, source, url }, sortOrder }) => ({
    id,
    original: `${mediaStoreBaseURL}/${url}`,
    sortOrder,
    source,
    thumbnail: `${mediaStoreBaseURL}/${url}`,
    url
  }));
};

const FullScreenButton = ({ isMobile, onClick }) => (
  <div className='absolute top-2 left-2'>
    <Image
      {...{
        alt: 'open product image',
        className: 'cursor-pointer',
        height: 0,
        onClick,
        src: `${staticMediaStoreBaseURL}/icons/resize-icon.svg`,
        style: {
          height: isMobile ? 24 : 32,
          width: isMobile ? 24 : 32
        },
        width: 0
      }}
    />
  </div>
);

const PDPProductImageSlider = ({ product: { productMedia = [] } }) => {
  const [isMobile] = useIsMobile();
  const imageSliderRef = useRef();

  const [currentIndex, setCurrentIndex] = useState(0);
  const [imageCarouselModalImage, setImageCarouselModalImage] =
    useState(false);

  const imageList = getRankedImages(parseProductMedia(productMedia));
  const isProductMediaFound = productMedia.length > 0;

  useEffect(() => {
    imageSliderRef?.current.exitFullScreen();
  }, []);

  return (
    <>
      <div className='mt-3 banner-overlay-thumbnail'>
        <ImageGallery
          items={imageList}
          onClick={() => {
            setImageCarouselModalImage(imageList[currentIndex]);
          }}
          onSlide={(currentIndexOfImage) =>
            setCurrentIndex(currentIndexOfImage)
          }
          ref={imageSliderRef}
          renderFullscreenButton={(onClick, isFullscreen) =>
            isProductMediaFound && (
              <FullScreenButton
                {...{
                  isFullscreen,
                  isMobile,
                  onClick: () =>
                    setImageCarouselModalImage(imageList[currentIndex])
                }}
              />
            )
          }
          showBullets={true}
          showNav={false}
          showPlayButton={false}
          slideOnThumbnailOver
          thumbnailPosition={isMobile ? 'bottom' : 'right'}
          useBrowserFullscreen={!isMobile}
        />
      </div>
      {imageCarouselModalImage && (
        <ImageCarouselModal
          {...{
            images: imageList,
            modalImage: imageCarouselModalImage,
            openImageModal: setImageCarouselModalImage
          }}
        />
      )}
    </>
  );
};

export default PDPProductImageSlider;
